<span translate="tdWb.nasdaqBasic.PRICE_DATA"></span>
<a [tdWbOverlayToggle]="overlayTemplate"
   role="button"
   class="td-wb-nasdaq-basic-pagenote__link"
   tdWbOverlayPosition="center-top"
   tdWbOverlaySize="small">
  <span translate="tdWb.nasdaqBasic.LEARN_MORE"></span>
</a>

<ng-template #overlayTemplate>
  <td-wb-overlay>
    <span class="td-wb-nasdaq-basic-pagenote__overlay-text"
          translate="tdWb.nasdaqBasic.OVERLAY_TEXT"></span>
  </td-wb-overlay>
</ng-template>
